/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as globals from "../globals";

export default function GoogleForm(props) {
  return (
    <div
      css={css`
        ${globals.card}
        padding: 10px 0;
        min-height: 514px;
        overflow: hidden;

        .freebirdFormviewerViewFooterEmbeddedFooterIconContainer {
          display: none;
        }

        #mG61Hd > div > div.freebirdFormviewerViewFooterEmbeddedBackground {
          display: none;
        }
      `}
    >
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSej02nDAYGfYWk-9KebkpAZrs7vkETg7Iz5j7Km8j9uvMc4rA/viewform?embedded=true"
        height="500"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        title="GoogleForm"
        overflow-x="hidden"
        css={css`
          width: 100%;

          body {
            overflow-x: hidden;
          }
        `}
      >
        Loading…
      </iframe>
    </div>
  );
}
